export default "__VITE_ASSET__d4739bc1__"